<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'SELECT_COUNTRY' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeCountryModal()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="ion-padding">
    <ion-row>
      <ion-col size="6" size-md="4" *ngFor="let country of availableCountries | filterAll">
        <div class="country-item"
             [class.selected]="isCountrySelected(country)"
             (click)="selectCountry(country)">
          <i *ngIf="country.flag !== 'other'"
             class="flag-icon flag-icon-{{ country.flag }}"
             [title]="country.name | translate">
          </i>
          <span class="country-name">{{ country.name | translate }}</span>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div class="ion-padding">
    <ion-button expand="block" color="tertiary" (click)="closeCountryModal()">{{ 'DONE' | translate }}</ion-button>
  </div>
</ion-content>